import initialState from './initialState';
import {PERSON_SELECT, PERSONMAP_FETCH, PERSONMAP_RECEIVE, PERSONMAP_APIERROR, PERSONMAP_ISLOADING} from '../actions/actionTypes';

export function personMap(state = initialState.personMap, action) {

  let newState;
  switch (action.type) {

    case PERSONMAP_RECEIVE:
        console.log('PERSONMAP_RECEIVE Action');
        newState = {
              ...state,
              ...action.personMap
          };
      return newState;

      case PERSON_SELECT:
        console.log('PERSON_SELECT Action');
        newState = {
              ...state,
              selectedUser: action.person
          };
      return newState;

     case PERSONMAP_ISLOADING:
        console.log('PERSONMAP_ISLOADING Action');
        newState = {
              ...state,
              isLoading: action.isLoading
          };
        return newState;
  
        

      default:
      return state;
  }
}

export function personMapHasErrored(state = false, action) {
  switch (action.type) {
        case PERSONMAP_APIERROR:
            console.log('PERSONMAP_APIERROR Action');
            return {hasErrored: action.hasErrored, errMsg: action.errMsg};

        default:
            return state;
  }
}

export function personMapIsLoading(state = false, action) {
    switch (action.type) {
        case PERSONMAP_ISLOADING:
            console.log('PERSONMAP_ISLOADING Action');
            return action.isLoading;

        default:
            return state;
  }
}